import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './HowItWorks.css';

const HowItWorks = () => {
  const [steps, setSteps] = useState([]);
  const [title, setTitle] = useState('How It Works');
  const [subtitle, setSubtitle] = useState('Simple setup, powerful results');

  useEffect(() => {
    fetchSteps();
  }, []);

  const fetchSteps = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const sections = response.data.data.sections || [];
        const aboutSection = sections.find(s => s.section_key === 'about');

        if (aboutSection && aboutSection.content) {
          const titleContent = aboutSection.content.find(c => c.content_key === 'about_title');
          const subtitleContent = aboutSection.content.find(c => c.content_key === 'about_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);

          // Extract steps
          const stepsData = [];
          for (let i = 1; i <= 4; i++) {
            const stepTitle = aboutSection.content.find(c => c.content_key === `about_step_${i}_title`);
            const stepDesc = aboutSection.content.find(c => c.content_key === `about_step_${i}_desc`);

            if (stepTitle && stepDesc) {
              stepsData.push({
                number: i,
                title: stepTitle.content_value,
                description: stepDesc.content_value
              });
            }
          }

          setSteps(stepsData);
        }
      }
    } catch (error) {
      console.error('Failed to fetch steps:', error);
    }
  };

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="steps">
          {steps.map((step) => (
            <div key={step.number} className="step">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;